import { r as registerInstance, g as getElement } from './core-a69618da.js';
import './readable-number-b11b551f.js';
import './index-ba7acc67.js';
import './index-87eae0eb.js';
import { y as yAxisService } from './y-axis.service-f48f1025.js';
var YAxis = /** @class */ (function () {
    function class_1(hostRef) {
        registerInstance(this, hostRef);
        /**
         * Lower limit of the axis
         *
         * @type {number}
         * @memberof YAxis
         */
        this.from = 0;
        /**
         * Upper limit of the axis
         *
         * @type {Number[]}
         * @memberof YAxis
         */
        this.to = 0;
        /**
         * Use this attribute to decide if the widget should be rerendered on window resize
         * Defaults to true
         */
        this.responsive = true;
        this._resizeListener = this._resizeListener.bind(this);
    }
    class_1.prototype.componentWillLoad = function () {
        addEventListener('resize', this._resizeListener);
    };
    class_1.prototype.componentDidUnload = function () {
        removeEventListener('resize', this._resizeListener);
    };
    class_1.prototype.render = function () {
        var element = this.element.previousElementSibling;
        var scale = [this.from, this.to];
        yAxisService.renderYAxis(element, scale);
    };
    class_1.prototype._resizeListener = function () {
        if (this.responsive) {
            this.element.forceUpdate();
        }
    };
    Object.defineProperty(class_1.prototype, "element", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(class_1, "style", {
        get: function () { return ".y-axis{--widget-axis-text-color:var(--as--color--type-01,#2c2c2c);--widget-axis-line-color:var(--as--color--ui-05,#b3b3b3)}.y-axis .tick text{width:30px;fill:var(--widget-axis-text-color);white-space:pre}.y-axis .tick line{stroke:var(--widget-axis-line-color);opacity:.1}.y-axis .tick line.zero{opacity:.5}.y-axis .domain{display:none}"; },
        enumerable: true,
        configurable: true
    });
    return class_1;
}());
export { YAxis as as_y_axis };
